interface LineItem {
    sku: string;
    name: string;
    description?: string;
    category?: string;
    unit_price: number;
    sale_price?: number;
    quantity: number;
    total_price: number;
    image_url?: string;
    product_url?: string;
}

interface MappedLineItem {
    sku: string;
    name: string;
    description?: string;
    category?: string;
    unitPrice: number;
    salePrice?: number;
    quantity: number;
    totalPrice: number;
    imageUrl?: string;
    productUrl?: string;
}

export default defineNuxtPlugin((nuxtApp) => {
    const runtimeConfig = useRuntimeConfig();

    let isLoaded = false;

    const initChatCloseListener = () => {
        if (window.zE) {
            window.zE('messenger:on', 'close', function() {
                const oaLiveChatWidget = document.getElementById("oa-live-support-widget");
                if( oaLiveChatWidget ) {
                    oaLiveChatWidget.style.display = "block";
                }
            });

            window.zE('messenger:on', 'open', function() {
                const oaLiveChatWidget = document.getElementById("oa-live-support-widget");
                if( oaLiveChatWidget ) {
                    oaLiveChatWidget.style.display = "none";
                }
            });
        }
    };

    const initChatButton = () => {
        const chatButton = document.querySelector('.oa-live-support__service--livechat');
        if (chatButton) {
            chatButton.addEventListener('click', function(e) {
                e.preventDefault();

                const checkZE = setInterval(() => {
                    if (window.zE) {
                        window.zE('messenger', 'open');

                        initChatCloseListener();
                        clearInterval(checkZE);
                    }
                }, 100);
            });
        }
    }

    const loadScript = (src: string) => new Promise<void>((resolve, reject) => {
        const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
        if (existingScript) {
            if (existingScript.dataset.loaded === 'true') resolve();
            else existingScript.addEventListener('load', () => resolve(), { once: true });
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', () => {
            script.dataset.loaded = 'true';
            resolve();
        }, { once: true });
        script.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), { once: true });
        document.head.appendChild(script);
    });

    

    const loadWhatsAppChat = async () => {
        // The WordPress WhatsApp widget depends on jQuery. Both assets are deferred
        // until the visitor interacts with the page, so they cannot affect the
        // initial render or Lighthouse's main-thread measurements.
        await loadScript(runtimeConfig.public.BASE_URL + 'jquery.js');

        // Load WhatsApp Chat CSS
        const cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = runtimeConfig.public.BASE_URL + 'api/wp-content/plugins/wp-whatsapp-chat/build/frontend/css/style.css';
        cssLink.type = 'text/css';
        document.head.appendChild(cssLink);

        // Load WhatsApp Chat JS
        await loadScript(runtimeConfig.public.BASE_URL + 'api/wp-content/plugins/wp-whatsapp-chat/build/frontend/js/index.js');
    };



    const loadClarity = () => {
        (function(w, d, s, i) {
            var f = d.createElement(s);
            f.type = "text/javascript";
            f.async = true;
            f.src = "https://www.clarity.ms/tag/" + i;
            var g = d.getElementsByTagName(s)[0];
            g.parentNode.insertBefore(f, g);
        })(window, document, "script", "5551h1xvqs");
    };

    const loadThirdPartyDelay = () => {
        if (process.client) {
            const loadAfterInteraction = () => {
                if (isLoaded) return;
                loadClarity();
                void loadWhatsAppChat();
                // loadInnity();
                isLoaded = true;
            };

            // Do not parse jQuery or chat code during initial rendering.
            // Any meaningful interaction, including scrolling, can start loading it.
            document.addEventListener('scroll', loadAfterInteraction, { once: true, passive: true });
            document.addEventListener('touchstart', loadAfterInteraction, { once: true, passive: true });
            document.addEventListener('mousemove', loadAfterInteraction, { once: true, passive: true });
            document.addEventListener('keydown', loadAfterInteraction, { once: true });
        }
    }

    nuxtApp.hook('app:mounted', () => {
        if( runtimeConfig.public.BASE_URL === 'https://www.skjewellery.com.my/') {
            console.log('loadThirdPartyDelay');
            loadThirdPartyDelay();
        }

        // zendeskScript();
    });
})
